var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-textarea',{staticClass:"mt-5",attrs:{"label":_setup.label,"value":_setup.noteValue,"rows":"5","no-resize":"","append-icon":_setup.savingIcon,"dense":""},on:{"input":_setup.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }